import { Navigate } from "react-router-dom"
import { useAuth } from "../../auth/store"
import type { UserRole } from "@/shared/entities/users"

export interface RoleProtectedRouteProps {
  redirect?: string
  rolesAllowed: UserRole[]
  children: React.ReactNode
}

export default function RoleProtectedRoute({
  rolesAllowed,
  children,
  redirect = "/dashboard",
}: RoleProtectedRouteProps) {
  const { user, isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!user || !rolesAllowed.includes(user.role)) {
    return <Navigate to={redirect} replace />
  }

  return <>{children}</>
}
